import React from "react";
import { Button } from "../../../designSystem/button/Button";
import { Flex } from "../../../designSystem/compositeComponents/FlexHelpers";
import { Toggletip } from "../../../designSystem/Toggletip";
import { TooltipWrapper } from "../../../designSystem/TooltipWrapper";
import { H1, H2 } from "../../../designSystem/typography/Heading";

export const TooltipOverview = (): JSX.Element => 
{
    return (
        <Flex flexDirection="column" gap={24}>
            <H1>Tooltip</H1>
            
            <H2>Plain Toggletip</H2>
            <Flex flexDirection='row' justifyContent="stretch" gap={16}>
                <Flex flexDirection='column' gap={16} style={{flexGrow:'1'}}>
                    <H2>On its own</H2>
                    <Toggletip>But we still have a tooltip</Toggletip>
                </Flex>
                <Flex flexDirection='column' gap={16} style={{flexGrow:'1'}}>
                    <H2>Next to ...</H2>
                    
                    <Toggletip>Lorem ipsum dolor sit amet</Toggletip>
                </Flex>
            </Flex>

            <H2>Tooltip Wrapper</H2>
            <Flex flexDirection='row' gap={16} alignItems="flex-start">
                <TooltipWrapper tooltip={<div>Lorem ipsum dolor sit amet</div>}>
                    just some text
                </TooltipWrapper>
                <TooltipWrapper tooltip={<div>Lorem ipsum dolor sit amet</div>}>
                    <span>covering a span</span>
                </TooltipWrapper>
                <TooltipWrapper tooltip={<div>Lorem ipsum dolor sit amet</div>}>
                    <Button variant="filled" icon="arrows_actions_fullscreen" text="around a button" onClick={() => alert('clicked!')} />
                </TooltipWrapper>
                <Flex flexDirection="column">
                    <TooltipWrapper tooltip={<div>Lorem ipsum dolor sit amet</div>}>
                        <Button variant="filled" icon="arrows_actions_fullscreen" text="around a button" onClick={() => alert('clicked!')} />
                    </TooltipWrapper>
                    <TooltipWrapper tooltip={<div>Lorem ipsum dolor sit amet</div>}>
                        <Button variant="filled" icon="arrows_actions_fullscreen" text="around a button" onClick={() => alert('clicked!')} />
                    </TooltipWrapper>
                </Flex>
            </Flex>
            
        </Flex>
    );
}